// src/services/eventSectionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getEventSections = async () => {
  return await axios.get(`${API_URL}/event-sections`);
};

const getEventSection = async (id) => {
  return await axios.get(`${API_URL}/event-sections/${id}`);
};

const createEventSection = async (eventSectionData) => {
  return await axios.post(`${API_URL}/event-sections`, eventSectionData);
};

const updateEventSection = async (id, eventSectionData) => {
  return await axios.put(`${API_URL}/event-sections/${id}`, eventSectionData);
};

const deleteEventSection = async (id) => {
  return await axios.delete(`${API_URL}/event-sections/${id}`);
};

export default {
  getEventSections,
  getEventSection,
  createEventSection,
  updateEventSection,
  deleteEventSection,
};
